define('app/views/base_landing_view',['app/setup', 'app/views/base_view'], function(takhfifan, baseView) {

  takhfifan.BaseLandingView = takhfifan.BaseView.extend({

    storeReferrer: function() {
      var _src = this.extractReferrer();

      if (!(_.isNull(_src) || _src == 0)) {
        this.setCookie({ name: 'source', value: _src, expires: 30 });
      }
    },

    initialize: function(options) {
      this.storeReferrer();
    },

    extractReferrer: function() {
      var _src = this.urlParam('utm_source');

      if (_.isNull(_src) || _src == 0) {
        var default_referrer = $('#tkh_referrer')

        if (default_referrer.length > 0) {
          return default_referrer.data('value');
        }
      }

      return _src;
    }
  });
});

